import { render, staticRenderFns } from "./attachmentButtons.vue?vue&type=template&id=42c3e60d&"
import script from "./attachmentButtons.vue?vue&type=script&lang=ts&"
export * from "./attachmentButtons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports